import React, { useContext } from "react"
import { Input, Radio } from "@mantine/core"

import { Icon } from "@/components/Icon"

import classes from "@/components/TopNavigation/components/MultiPacSelector/Dropdown/Dropdown.module.css"
import { MultiPacSelectorContext } from "@/components/TopNavigation/components/MultiPacSelector/MultiPacSelectorContext"
import { escapeRegExp } from "shared/imports/sharedHelperFunctions"

type Props = {
    isMobile?: boolean
}

export const Dropdown = ({ isMobile }: Props) => {
    const { selectedPac, selectNewPac, options, search, setSearch, isLoading } = useContext(MultiPacSelectorContext)
    const radioRootClasses = isMobile ? `${classes.radioRoot} ${classes.radioRootMobile}` : classes.radioRoot
    const searchRegex = new RegExp(escapeRegExp(search), "i")
    const searchClass = isMobile ? classes.searchWrapperMobile : classes.searchWrapper

    return (
        <>
            <div className={searchClass}>
                <Input
                    icon={<Icon icon="search" className={classes.searchIcon} />}
                    placeholder="Search by PAC name"
                    type="search"
                    aria-label="PAC Selector"
                    onChange={(e) => setSearch(e.target.value)}
                    className={classes.input}
                    value={search}
                    data-autofocus
                />
            </div>

            <div className={classes.optionsWrapper}>
                <Radio.Group
                    value={selectedPac}
                    onChange={selectNewPac}
                    className={classes.radioGroup}
                    aria-label="PAC Selector"
                >
                    {options
                        ?.filter((option) => searchRegex.test(option.acronym))
                        .map((option) => (
                            <Radio
                                key={option.id}
                                value={option.id}
                                classNames={{
                                    inner: classes.radioInner,
                                    root: radioRootClasses,
                                    label: classes.radioLabel,
                                    radio: classes.radio,
                                    labelWrapper: classes.radioLabelWrapper,
                                    body: classes.radioBody,
                                }}
                                label={
                                    <div className={classes.labelContainer}>
                                        <p title={option.acronym}>{option.acronym}</p>
                                        {selectedPac === option.id && <Icon icon="check" size="sm" />}
                                    </div>
                                }
                                disabled={isLoading}
                            />
                        ))}
                </Radio.Group>
            </div>
        </>
    )
}
